export default {"src":"/_next/static/media/deco_checkout_trash.3e8a4423.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};